import {createContext, useContext, useEffect, useRef, useState} from "react";
import {getToken} from "../../utils/utils";
import {laborApiError, laborRequest} from "./laborApi";

export type LaborAccess = {
  enabled: boolean; can_access: boolean; is_admin: boolean;
  management_password_required?: boolean;
  management_unlocked?: boolean;
  writes_enabled: boolean; sections: string[];
  sheet_status_writes_enabled?: boolean;
  configuration_writes_enabled?: boolean;
  submission_writes_enabled?: boolean;
};
// UI state only. Every API request is independently authorized by the server.
export const LaborReadOnlyContext = createContext(false);
export const LaborPurchaseArchiveContext = createContext(false);
export const usePurchaseArchiveAccess = () => useContext(LaborPurchaseArchiveContext);
export const useLaborReadOnly = () => useContext(LaborReadOnlyContext);

export function useLaborAccess(identity = "") {
  const token = getToken();
  const key = `${identity}:${token || ""}`;
  const [result, setResult] = useState<{key: string; access: LaborAccess} | null>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [revision, setRevision] = useState(0);
  const sequence = useRef(0);
  useEffect(() => {
    let active = true;
    const request = ++sequence.current;
    setLoading(true); setError("");
    laborRequest<LaborAccess>("GET", "status/").then(access => {
      if (!access || !Array.isArray(access.sections) || typeof access.enabled !== "boolean" || typeof access.is_admin !== "boolean" || typeof access.can_access !== "boolean" || typeof access.writes_enabled !== "boolean") throw new Error("Labor access could not be verified.");
      if (active && request === sequence.current) setResult({key, access});
    }).catch(failure => {if (active && request === sequence.current) {setResult(null); setError(laborApiError(failure));}})
      .finally(() => {if (active && request === sequence.current) setLoading(false);});
    return () => {active = false;};
  }, [key, revision]);
  useEffect(() => {
    const refresh = () => setRevision(value => value + 1);
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, []);
  return {access: result?.key === key ? result.access : null, error, loading,
    retry: () => setRevision(value => value + 1)};
}


